import { Button, Heading, HStack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { LucidePencil } from 'lucide-react';
import { iconSize } from '@duke-hq/ui/constants/scalable';

export function SectionHeading({
  children,
  onEdit,
  editDetails,
  action,
}: {
  children: React.ReactNode;
  onEdit?: () => void;
  editDetails?: boolean;
  action?: React.ReactNode;
}): React.ReactElement {
  return (
    <HStack justifyContent="space-between">
      <Heading fontSize="lg" size="xs">
        {children}
      </Heading>
      {action != null ? (
        action
      ) : editDetails ? (
        <Button leftIcon={<LucidePencil size={iconSize.sm} />} variant="ghost" onClick={onEdit}>
          <Trans>Edit</Trans>
        </Button>
      ) : null}
    </HStack>
  );
}
